import { MenuList as MuiMenuList } from "@mui/material";
import MenuListItem from "./MenuListItem";
import MenuItem from "./MenuItem";
import useMenuSidebar from "../hooks/useMenuSidebar";

const MenuList = () => {
  const { menuList } = useMenuSidebar();

  return (
    <MuiMenuList>
      {menuList.map(menuItem =>
        menuItem.subItems ? (
          <MenuListItem
            key={menuItem.key}
            subItems={menuItem.subItems || []}
            startIcon={menuItem.icon}
            text={menuItem.title}
          />
        ) : (
          <MenuItem key={menuItem.key} menuItem={menuItem} />
        ),
      )}
    </MuiMenuList>
  );
};
export default MenuList;
